import * as React from 'react';
import { useMemo } from 'react';
import NavShell from './NavShell';
import HomeIcon from '@mui/icons-material/Home';
import DevicesIcon from '@mui/icons-material/Devices';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

function WorkerNavBar({ children }) {
  const navItems = useMemo(() => [
    { key: 'home', label: 'Home', icon: <HomeIcon />, path: '/home' },
    { key: 'devices', label: 'Maszyny', icon: <DevicesIcon />, path: '/workerDevices' },
    { key: 'gatekeeper', label: 'Obecności', icon: <EventAvailableIcon />, path: '/workerGateKeeper' },
  ], []);

  return (
    <NavShell
      storageKeyPrefix="worker"
      profileHref="/WorkerProfile"
      allowedProfileTypes={['worker']}
      navItems={navItems}
    >
      {children}
    </NavShell>
  );
}

export default WorkerNavBar;
